import request from "@/utils/request";

const yqwxApiHost = 'qywx.yqaitech.com';
const yqwxApiProtocol = 'https:';
export const yqwxRsApiHost = 'yuanquan.ttrushi.com';
export const yqwxRsApiProtocol = 'https:';

/**
 * 获取企业微信授权链接
 * @param {*} params 
 */
export const getAuthUrl = params => request.get2(`${yqwxApiProtocol}//${yqwxApiHost}/qywx/auth/web/getAuthUrl`, params);

/**
 * 获取企业微信名片
 * 
 * @param {*} params 
 */
export const getCorpUserCardInfo = params => request.post(`${yqwxApiProtocol}//${yqwxApiHost}/qywx/getCorpUserCardInfo`, params);

/**
 * 绑定外部账号
 * @param {object} params 
account	外部绑定的帐号，如企业微信open_userid	query	true	string
accountType	外部绑定的帐号，qywx企业微信	query	true	string
openid	服务号用户openid	query	true	string
 */
export const bindUserAccount = params => request.post2(`${yqwxRsApiProtocol}//${yqwxRsApiHost}/qc-webapp/m/user/account/bind`, params);


/**
 * 通过服务号openid获取用户绑定的外部帐号信息
openid	用户openid	query	true	string
accountType	外部绑定的帐号，qywx企业微信	query	false	string
 * @param {object} params 
 */
export const getExtUserIdByOpenid = params => request.get2(`${yqwxRsApiProtocol}//${yqwxRsApiHost}/qc-webapp/m/user/openid`, params);



/**
 * 通过绑定的外部帐号ID获取用户
 * @param {object} params 
account	外部绑定的帐号，如企业微信open_userid	query	true	string
appid	服务号APPID	query	true	string
accountType	外部绑定的帐号，qywx企业微信	query	false	string
 */
export const getUserByAccount = params => request.get(`${yqwxRsApiProtocol}//${yqwxRsApiHost}/qc-webapp/user/account`, params);